<!--
 Created by Xuz on 2020/02/15.
 xuz[at]live[dot]cn
 流程编辑器 - 编辑流程
-->
<template>
    <a-modal title="编辑流程"
             :width="1100"
             :visible="visible"
             :maskClosable="false"
             @ok="onSubmit"
             @cancel="onCancel"
             :confirmLoading="modalLoading"
             class="wf-editor"
             destroyOnClose>
        <a-alert :message="message" banner :type="messageType"/>
        <div id="WFContainer" style="width:1100px;height:500px;margin-bottom:4px" tabindex="0">
        </div>

        <WFObject ref="objectNode" />
        <WFStarNode ref="startNode" />
        <WFEndNode ref="endNode" />
        <WFTransNode ref="transNode" />
        <WFLink ref="linkNode" />
        <WFCommonNode ref="commonNode" />

    </a-modal>
</template>

<script>
import * as WFC from './js/WFConstants'
import Workflow from './js/WorkFlow'
import WFValidator from './js/WFValidator'
import WFDeparser from './js/WFDeparser'
import WFObject from './WFObject'
import WFStarNode from './WFStarNode'
import WFEndNode from './WFEndNode'
import WFTransNode from './WFTransNode'
import WFLink from './WFLink'
import WFCommonNode from './WFCommonNode'
import qs from 'qs'

export default {
  name: 'WFEdit',
  components: {
    WFObject,
    WFStarNode,
    WFEndNode,
    WFTransNode,
    WFLink,
    WFCommonNode
  },
  props: {
  },
  data () {
    return {
      visible: false,
      modalLoading: false,
      message: '流程设计器',
      messageType: 'warning',
      wf: null,
      force: false,
      process: {},
      formData: {
        actionType: 'edit',
        procId: null,
        svgSource: null,
        activitySource: null,
        commentSource: null,
        state: null
      }
    }
  },
  methods: {
    preWFEdit (procId, force) {
      this.addEventListener()
      this.visible = true
      this.formData.procId = procId
      this.force = force
      this.initWorkFlow()
    },
    addEventListener () {
      window.addEventListener('keyup', this.onKeyUp)
    },
    removeEventListener () {
      window.removeEventListener('keyup', this.onKeyUp)
    },
    onSubmit (event) {
      let forceSave = false
      if (event.altKey && event.ctrlKey) {
        if (confirm('确认启用强制保存功能？')) {
          forceSave = true
        }
      }
      // 不是强制保存时，检查配置数据是否正确
      if (!forceSave) {
        let wfValidator = new WFValidator(this.wf)
        wfValidator.check()
        if (!wfValidator.getCheckResult()) {
          // 有问题
          alert(wfValidator.getErrorList().join('\n'))
          return
        }
      }

      this.wf.setUnSelectLastElement()
      this.wf.onBeforeSave()
      const oSvgJs = this.wf.getSvgJs()
      const oXml = this.wf.getWfXml()
      let wfDeparser = new WFDeparser()
      this.formData.svgSource = wfDeparser.deparse(oSvgJs.node)
      this.formData.activitySource = oXml.getSource()
      this.formData.commentSource = oXml.getCommentsXml()
      this.$http.post('/api/1/workflow/design/save.json', qs.stringify(this.formData)).then(resp => {
        this.closeModal()
        this.$emit('success')
      })
    },
    onCancel () {
      this.closeModal()
      this.$emit('cancel')
    },
    closeModal () {
      window.removeEventListener('keyup', this.onKeyUp)
      this.visible = false
    },
    initWorkFlow () {
      const that = this
      this.$http.get('/api/1/workflow/design/get_process.json?id=' + this.formData.procId).then(function (resp) {
        that.process = resp.result
        that.formData.state = that.process.state

        let placeholder = document.createElement('div')
        placeholder.innerHTML = that.process.svg
        let svg = placeholder.firstChild
        document.getElementById('WFContainer').appendChild(svg)

        let options = { procId: that.process.id, mode: WFC.WF_OPERATION_EDIT, force: that.force, state: that.process.state }
        that.wf = new Workflow(that, 'WFDesigner', null, options)

        // 意见
        let comments = that.process.extras.comments
        let wfXml = that.wf.getWfXml()
        for (let i = 0; i < comments.length; i++) {
          let item = comments[i]
          wfXml.addComment({ uuid: item.opinionId, name: item.opinionName, order: item.seq })
        }
      })
    },
    setMessage (message) {
      if (message === '') {
        this.message = '流程设计器'
        this.messageType = 'warning'
      } else {
        this.message = message
        this.messageType = 'error'
      }
    },
    onKeyDown () {
      console.log('onKeyDown')
    },
    onEditObjectNode (wfNode) {
      this.$refs.objectNode.show(wfNode)
    },
    onEditStartNode (wfNode) {
      this.$refs.startNode.show(wfNode)
    },
    onEditCommonNode (wfNode) {
      this.$refs.commonNode.show(wfNode)
    },
    onEditEndNode (wfNode) {
      this.$refs.endNode.show(wfNode)
    },
    onEditTransNode (wfNode) {
      this.$refs.transNode.show(wfNode)
    },
    onEditLinkNode (wfNode) {
      this.$refs.linkNode.show(wfNode)
    },
    onKeyUp (event) {
      const keyCode = event.keyCode
      // 90 - z
      if (event.ctrlKey && event.altKey && keyCode === 90) {
        this.fixRoutes()
      }
    },
    fixRoutes () {
      console.log('fixRoutes')
      let routes = []
      let wfXml = this.wf.getWfXml()
      for (let i = 0; i < wfXml.dRoutes.childNodes.length; i++) {
        let dRoute = wfXml.dRoutes.childNodes[i]
        if (dRoute.childNodes.length === 0) {
          const uuid = dRoute.getAttribute('uuid')
          const name = dRoute.getAttribute('name')
          wfXml.dRoutes.removeChild(dRoute)
          delete wfXml.aEls[uuid]
          console.log('问题节点: ' + uuid + ' / ' + name)
          routes.push(name)
        }
      }
      if (routes.length > 0) {
        alert('修复问题节点: ' + routes.join(','))
      } else {
        alert('没有找到问题节点')
      }
    }
  }
}
</script>

<style lang="less">
    .wf-editor .ant-modal-body {
        padding: 0 !important;
    }

    #WFDesigner text {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
